/**
 SSE Emitter 지원 유틸리티
 @packageDocumentation
 */

export interface SseEmitterOption {
  /**
   * URL
   */
  url: string

  /**
   * 메시지 수신 시 처리 콜백
   */
  onmessage?: ((this: EventSource, ev: MessageEvent) => any) | null

  /**
   * 에러 수신 시 처리 콜백
   */
  onerror?: ((this: EventSource, ev: MessageEvent) => any) | null

  /**
   * 오픈 시 처리 콜백
   */
  onopen?: ((this: EventSource, ev: MessageEvent) => any) | null
}

/**
 * sse 연결
 * @param option 옵션
 */
export const connect = (option: SseEmitterOption): EventSource => {
  const eventSource = new EventSource(option.url)

  if (option.onmessage) {
    eventSource.onmessage = option.onmessage
  }

  if (option.onerror) {
    eventSource.onerror = option.onerror
  }

  if (option.onopen) {
    eventSource.onopen = option.onopen
  }

  return eventSource
}
